import React, { ReactNode } from "react";

interface RectangleProps {
  children: ReactNode; // Text displayed inside the rectangle
  className?: string; // Optional custom styles
}

export const RectangleContainer: React.FC<RectangleProps> = ({
  children,
  className,
}) => {
  return (
    <div
      className={`p-4 border-b-2 border-l-2 border-r-2 border-dark-gray bg-white first:border-t-2 first:rounded-t-lg last:rounded-b-lg ${className || ""}`}
    >
      {children}
    </div>
  );
};
